import {
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "@tanstack/react-query";
import { PostAllCBSNsList } from "../../api/api";
import { useState } from "react";

type GetCBSNsPropsList = {
  open: boolean;
  authToken: string;
  cbsn: string;
};

type CBSN = {
  CBSN: string;
  // isDefaultTag: boolean;
  // occurrence: number;
};

type CBSNList = {
  status: string;
  msg: CBSN[];
};

export const useListCBSNs = ({
  open,
  authToken,
  cbsn,
}: GetCBSNsPropsList): UseInfiniteQueryResult<
  CBSNList,
  Error
> => {
  const [totalCount, setTotalCount] = useState(0);
  let limit = 25;

  return useInfiniteQuery({
    queryKey: ["listCBSNs", open, cbsn],
    initialPageParam: { skip: 0, limit },
    staleTime: 1000 * 60 * 5,
    queryFn: ({
      pageParam,
    }: {
      pageParam: { skip: number; limit: number };
    }) =>
      PostAllCBSNsList({
        authToken,
        body: {
          device: pageParam,
          filter: {
            CBSN: cbsn,
          },
        },
      }).then((res) => {
        setTotalCount(res?.count);
        return res;
      }),
    enabled: !!authToken && !!open,
    getNextPageParam: (
      lastPage: CBSNList,
      allPages: CBSNList[]
    ) => {
      const totalFetched = allPages.flatMap(
        (page) => page.msg
      ).length;

      // Stop fetching if the total fetched rows reach or exceed the total count
      if (totalFetched >= totalCount) {
        return undefined;
      }

      // Return the skip value for the next page
      return { skip: allPages.length * limit, limit };
    },
  });
};
